import { initializeApp } from 'firebase/app';


//import { firebaseConfig } from './firebase_key';
import {  getAuth } from "firebase/auth";

// TODO: Replace the following with your app's Firebase project configuration

const firebaseConfig = {
    apiKey: "AIzaSyA_MKY9uG99P9uDVjAEOIMlJ_IBgItNPhc",
    authDomain: "ofc-site-map.firebaseapp.com",
    projectId: "ofc-site-map",
    storageBucket: "ofc-site-map.appspot.com",
    messagingSenderId: "528311860908",
    appId: "1:528311860908:web:08c9e1bbf962ca54892909"
  };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

